import { usePublicProfileData } from '@/context/PublicProfileContext';
import { useLinkTap } from '@/hooks/useLinkTap';
import { SocialIcon } from '@/components/shared/SocialIcon';
import { serviceMeta } from '@/data/services';
import type { SocialService } from '@/data/services';

export function Socials() {
  const { links } = usePublicProfileData();
  const tap = useLinkTap();

  const socials = links.filter((l) => l.kind === 'social');
  if (socials.length === 0) return null;

  return (
    <div className="ap-socials">
      {socials.map((s) => {
        const meta = serviceMeta(s.service);
        return (
          <a
            key={s.id}
            href={s.url}
            className="ap-social-sticker"
            target="_blank"
            rel="noreferrer"
            onClick={() => tap(s.id)}
          >
            <span
              className="ap-social-sticker__icon"
              style={{ '--social-color': meta?.color } as React.CSSProperties}
            >
              <SocialIcon icon={s.service as SocialService} />
            </span>
            <span className="ap-social-sticker__name">
              {meta?.name ?? s.service}
            </span>
          </a>
        );
      })}
    </div>
  );
}
